import { render, staticRenderFns } from "./AgreementsLoader.vue?vue&type=template&id=4a04a1eb&"
import script from "./AgreementsLoader.vue?vue&type=script&lang=js&"
export * from "./AgreementsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports